import { ClockChunky } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import { ToggleChip } from '@eventbrite/marmalade';
import React from 'react';
import { v4 as UUID } from 'uuid';
import styles from './BrowseByDate.module.scss';
import { BrowseByDateMap } from './utils/BrowseByDateMap';

export interface BrowseByDateProps {
    location_slug: string;
    language_code: string;
}

export const BrowseByDate = ({
    location_slug,
    language_code,
}: BrowseByDateProps) => {
    const dates = BrowseByDateMap({ location_slug, language_code });

    const dateChips = dates.map((date) => (
        <a href={date.url} key={UUID()}>
            <ToggleChip
                icon={<ClockChunky />}
                iconTreatment="alwaysShow"
                aria-label={date.ariaLabel}
                className={styles.iconSVG}
            >
                {date.text}
            </ToggleChip>
        </a>
    ));

    return (
        <section className={styles.section} data-testid="browse-by-date">
            <div className={styles.browseByDateContainer}>
                <span className={styles.title}>
                    {gettext('Event time options')}
                </span>
                <div className={styles.dateContainer}>{dateChips}</div>
            </div>
        </section>
    );
};
